import React, { useEffect, useRef, useState } from 'react';
import { Modal, Icon, Input, Row, Col } from 'antd';
import { isValidGuid } from '@app/helpers/geradorGuid';
import { InputLabel } from '@app/components';
import {
  getByIdMinuta,
  postGerarMinuta,
  putStatusMinutaByCodigo,
} from '@app/api/minuta/Minutas';

import { Button, GridView, useRouter } from '@digital/ui';
import MinutaCabecalho from '../compontents/MinutaCabecalho';
import MinutaContent from '../compontents/MinutaContent';

import { EStatusCodigoMinuta } from '@app/enums/EStatusCodigoMinuta';
import { IMinuta, IMinutaVariavelItemClausula } from '@app/models/MinutaModels';

import { readFileSync } from 'fs';
import { hasPermission } from '@app/helpers/permissions';

const { confirm } = Modal;

const MinutaCustomizada = () => {
  const params = new URLSearchParams(location.search);
  const minutaIdParam = isValidGuid(params.get('id') || '') ? params.get('id') : null;

  const { history } = useRouter();

  const [minuta, setMinuta] = useState<IMinuta>({} as IMinuta);
  const [minutaOriginal, setMinutaOriginal] = useState<IMinuta>({} as IMinuta);
  const [minutaVariaveis, setMinutaVariaveis] = useState<IMinutaVariavelItemClausula[]>([]);

  const refContentHtml = useRef<HTMLDivElement>(null);

  //#region Consultas na API
  const initMinuta = async () => {
    if (minutaIdParam) {
      const minutaApi = (await getByIdMinuta(minutaIdParam)) || ({} as IMinuta);

      if (minutaApi.minutaVariaveisItemClausula) {
        setMinutaVariaveis(minutaApi.minutaVariaveisItemClausula);
      }

      setMinuta(minutaApi);
      setMinutaOriginal(minutaApi);

      atualizarConteudoComVariaveis(minutaApi, minutaApi.minutaVariaveisItemClausula);
    }
  };
  //#endregion

  useEffect(() => {
    initMinuta();
  }, []);

  useEffect(() => {
    initMinuta();
  }, [minutaIdParam]);

  const handlerClickCustomizeMinuta = async () => {
    await putStatusMinutaByCodigo(minuta.id, EStatusCodigoMinuta['Em Customizacao']);
    history.push(`/minutas/customizacaoDaMinuta?id=${minutaIdParam}`);
  };

  const handlerClickGenerateMinuta = async () => {
    var css = '<style>' + (await readFileSync('src/views/Minuta/Minutas/compontents/index.css', 'utf8')) + '</style>';

    let varEmpty = [] as string[];
    minutaVariaveis.forEach(v => {
      if (v.valor.length == 0 || v.valor.replaceAll(' ', '').length == 0) {
        varEmpty.push(v.nome);
      }
    });

    if (varEmpty.length > 0) {
      const title =
        varEmpty.length == 1
          ? `A variável ${varEmpty.join(',')} está vazia`
          : `As variáveis ${varEmpty.join(',')} estão vazias`;

      await confirm({
        title: title,
        icon: <Icon type="info-circle" />,
        onOk: async () => {
          return;
        },
        onCancel() {
          return;
        },
      });
      return;
    }

    const html = `
		<!DOCTYPE HTML PUBLIC>
		<html>
      <head>
        ${css}
      </head>
      <body>
        ${(refContentHtml.current && refContentHtml.current.innerHTML) || document.body.innerHTML}
      </body>
    </html>
    `;

    postGerarMinuta({
      minutaId: minuta.id,
      htmlMinuta: html,
      variaveis: minutaVariaveis,
    }).then(data => {
      if (data) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_ANALISE'])) {
          history.push(`/demanda/questionario/${minuta.demanda.id}/analise`);
        } else {
          history.push(`/minutas`);
        }
      }
    });
  };

  const atualizarConteudoComVariaveis = (
    minutaOriginal: IMinuta,
    minutaVariaveisTemp: IMinutaVariavelItemClausula[],
  ) => {
    let minutaTemp = JSON.parse(JSON.stringify(minutaOriginal)) as IMinuta;

    minutaVariaveisTemp.map(variavel => {
      minutaTemp.minutasPorTipoClausula.map(tipo => {
        tipo.minutaClausulas.map(clausula => {
          clausula.itens.map(item => {
            if (variavel.valor) {
              item.descricaoHtml = item.descricaoHtml.replaceAll(variavel.nome, variavel.valor);
            }
          });
        });
      });
    });

    setMinuta(minutaTemp);
  };

  const changeInputVariable = (variavelId: string, value: string) => {
    let minutaVariaveisTemp = [...minutaVariaveis];
    let varriavelIdx = minutaVariaveis.findIndex(v => v.id == variavelId);
    minutaVariaveisTemp[varriavelIdx].valor = value;
    setMinutaVariaveis(minutaVariaveisTemp);

    atualizarConteudoComVariaveis(minutaOriginal, minutaVariaveisTemp);
  };

  //#region Renders
  const renderSider = () =>
    minutaVariaveis && minutaVariaveis.length > 0 ? (
      minutaVariaveis.map(variavel => (
        <InputLabel key={variavel.id} label={variavel.nome}>
          <Input
            value={variavel.valor}
            onChange={e => {
              changeInputVariable(variavel.id, e.target.value);
            }}
          />
        </InputLabel>
      ))
    ) : (
      <span>Não existe variáveis para preencher</span>
    );

  const renderContent = () =>
    minuta.minutasPorTipoClausula &&
    minuta.minutasPorTipoClausula.length > 0 && (
      <div ref={refContentHtml}>
        <MinutaContent
          minutasPorTipoClausula={minuta.minutasPorTipoClausula || []}
          onExecuteAnAfterActionHandle={async () => {
            await initMinuta();
          }}
          enableTooltip={false}
        />
      </div>
    );

  const renderConteudoMinutaCustomizada = () => (
    <Row
      style={{
        background: '#fff',
        padding: 8,
        margin: 0,
      }}>
      <Col
        span={6}
        style={{
          overflow: 'hidden',
          paddingLeft: 8,
          paddingRight: 16,
        }}>
        <div>{renderSider()}</div>
      </Col>
      <Col
        span={18}
        style={{
          padding: 16,
          margin: 0,
          borderLeft: '1px solid  #ccc',
        }}>
        {renderContent()}
        {/* <Row>
          <Button
            key="gerar-minuta-customizada"
            icon="ui-save"
            type="primary"
            style={{
              float: 'right',
              marginTop: 24,
              marginLeft: 8,
            }}
            onClick={handlerClickGenerateMinuta}>
            GERAR MINUTA
          </Button>
          <Button
            key="customizar-customizada"
            icon="commons-edit"
            type="primary"
            style={{
              float: 'right',
              marginTop: 24,
            }}
            onClick={handlerClickCustomizeMinuta}>
            CUSTOMIZAR
          </Button>
        </Row> */}
      </Col>
    </Row>
  );

  const renderActions = (): React.ReactNode[] => [
    <Button
      key="customizar-customizada"
      icon="commons-edit"
      type="primary"
      onClick={handlerClickCustomizeMinuta}>
      CUSTOMIZAR
    </Button>,
    <Button
      key="gerar-minuta-customizada"
      icon="ui-save"
      type="primary"
      onClick={handlerClickGenerateMinuta}>
      GERAR MINUTA
    </Button>,
  ]

  //#endregion

  return (
    <GridView noform icon="ui-list" id="preencherMinuta" title="Minuta Customizada">
      {minuta && <MinutaCabecalho minuta={minuta} actions={renderActions()} />}
      {renderConteudoMinutaCustomizada()}
    </GridView>
  );
};

export default MinutaCustomizada;
